import * as React from 'react';
import { PCImage } from 'app/design/primitives/image';
import { images } from 'app/design/images';

export default function IntroInsured({
  width = 317,
  height = 216,
  maxWidth,
}: {
  width?: number;
  height?: number;
  maxWidth?: number;
}) {
  return <PCImage height={height} source={images.introInsured} width={width} maxWidth={maxWidth} />;
}
